// Username del cliente
const USERNAME = 'las-tias'

// Título de la web
const TITULO = "Las Tias | Online menu"

// Color del navbar(claro=true/oscuro=false)
const COLOR_NAVBAR_CLARO = false;

// Color del cuerpo(claro=true/oscuro=false)
const COLOR_CUERPO_CLARO = false;

// Activar banner(si=true/no=false)
const BANNER_ACTIVADO = true;

// Extensión del archivo de banner(ej: png, jpg, etc...)
const BANNER_EXTENSION = 'jpg';

// Activar 'Todos' en categoría(si=true/no=false)
const CATEGORIA_TODOS_ACTIVADO = false;

// Footer de forest activado(si=true/no=false)
const FOOTER_ACTIVADO = true;

// Color del footer de forest(claro=true/oscuro=false)
const FOOTER_CLARO = true;

// Botón de WhatsApp activado(si=true/no=false)
const BOTON_WHATSAPP_ACTIVADO = false;

// Número de WhatsApp(ej: 11 xxxx xxxx)
const NUMERO_WHATSAPP = '1100000000';

export {USERNAME, TITULO, COLOR_NAVBAR_CLARO, COLOR_CUERPO_CLARO, BANNER_ACTIVADO, BANNER_EXTENSION, CATEGORIA_TODOS_ACTIVADO, FOOTER_ACTIVADO, FOOTER_CLARO, BOTON_WHATSAPP_ACTIVADO, NUMERO_WHATSAPP}